import { css } from "@emotion/react";

import { Button } from "components/shared/library/Button";
import { Typography } from "components/shared/library/Typography";

import { useRecentJobSearches } from "utils/jobsSearch";
import { down } from "utils/mediaQueryStrings";

import { black, white } from "constants/colors";

import { RecentJobSearchItem } from "./RecentJobSearchItem";

const style = {
  card: css({
    borderRadius: 16,
    background: white,
    padding: "24px 12px 24px 12px",
    gap: 24,
    display: "flex",
    flexDirection: "column",
  }),
  header: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    [down("smallMobile")]: { flexWrap: "wrap" },
  }),
  title: css({
    display: "flex",
    gap: 8,
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "0px 12px 0px 12px",
  }),
  slidingContent: css({
    display: "flex",
    gap: 8,
    width: "fit-content",
  }),
  searchItems: css({
    display: "flex",
    flexDirection: "column",
    gap: 6,
  }),
};

export const RecentJobSearches = () => {
  const { recentSearches, clearRecentSearches } = useRecentJobSearches();

  const filteredRecentSearches = recentSearches.filter((r) => r.search?.value);

  return (
    <div css={style.card}>
      <div css={style.header}>
        <div css={style.title}>
          <Typography size="L" weight="bold" color={black}>
            Recent job searches
          </Typography>
          <Button
            size="medium"
            color="gray"
            onClick={() => {
              clearRecentSearches();
            }}
          >
            Clear all
          </Button>
        </div>
      </div>
      <div css={style.searchItems}>
        {filteredRecentSearches.length === 0 && (
          <Typography size="S" customCss={style.title}>
            No recent searches
          </Typography>
        )}
        {filteredRecentSearches.map((r, i) => (
          <RecentJobSearchItem
            key={i}
            jobSearch={r}
            isLast={i === filteredRecentSearches.length - 1}
          />
        ))}
      </div>
    </div>
  );
};
